import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Create = loadable(() => import('./Create'), {});
export const CreatePayments = loadable(() => import('./CreatePayments'), {});
export const PaymentTemplates = loadable(() => import('./PaymentTemplates'), {});
export const Simulate = loadable(() => import('./Simulate'), {});
